var _path, _path2, _path3, _path4, _circle, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGovfulllogosmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 168,
    viewBox: "0 0 204 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m126.67,80.03l23.63,-0.05l-0.4,0.28c0.75,-2.82 1.32,-5.65 1.84,-8.53c0.52,-2.89 0.93,-5.77 1.27,-8.66c0.75,-5.77 1.27,-11.59 1.67,-17.42l0.29,0.4l-62.43,-21.69l1.56,0l-63.58,21.69l0.29,-0.4c0.28,3.17 0.63,6.35 1.03,9.52c0.41,3.17 0.93,6.35 1.5,9.46c0.58,3.12 1.27,6.23 2.02,9.35c0.81,3.05 1.73,6.11 2.83,9.05c0.28,0.75 -0.12,1.56 -0.87,1.85c-0.75,0.29 -1.56,-0.12 -1.84,-0.87l0,-0.05c-0.98,-3.12 -1.73,-6.29 -2.42,-9.46c-0.64,-3.18 -1.16,-6.41 -1.56,-9.58c-0.41,-3.23 -0.75,-6.4 -0.98,-9.64c-0.23,-3.23 -0.46,-6.4 -0.52,-9.63c0,-0.17 0.12,-0.35 0.23,-0.4l62.31,-25.1c0.52,-0.23 1.1,-0.17 1.56,0l61.16,25.15c0.17,0.06 0.23,0.24 0.23,0.41c-0.4,5.83 -0.92,11.65 -1.67,17.48c-0.41,2.88 -0.81,5.82 -1.27,8.65c-0.52,2.89 -1.1,5.77 -1.85,8.6c-0.05,0.17 -0.17,0.29 -0.34,0.29l-0.06,0l-24.67,3.46c-1.15,0.05 -2.19,-0.81 -2.25,-2.02c-0.06,-1.16 0.81,-2.19 2.02,-2.25c0,0.11 1.21,0.11 1.27,0.11z",
    fill: "white",
    id: "svg_1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m64.53,96.94l-25.02,-0.98l0.23,-0.29c1.15,3.17 2.65,6.23 4.27,9.17c1.61,3 3.34,5.88 5.18,8.71c3.75,5.6 7.9,10.9 12.51,15.81c2.31,2.48 4.67,4.84 7.15,7.09c2.48,2.25 5.07,4.39 7.67,6.47c5.3,4.09 11.53,7.78 17.35,11.01l-2.25,0c2.88,-1.67 5.19,-3.57 8.01,-5.53c2.83,-1.97 5.59,-4.04 8.3,-6.23c5.42,-4.33 10.55,-8.95 15.34,-13.97c4.78,-5.01 9.16,-10.44 13.02,-16.21c1.96,-2.88 3.64,-5.94 5.25,-9c1.61,-3.11 2.94,-6.28 4.15,-9.57c0.06,-0.12 0.17,-0.18 0.29,-0.12c0.11,0.06 0.17,0.17 0.11,0.29c-1.03,3.35 -2.25,6.63 -3.69,9.87c-1.44,3.17 -3.05,6.34 -4.9,9.34c-3.57,6.06 -7.78,11.77 -12.39,17.08c-4.61,5.36 -9.62,10.32 -14.93,15c-2.65,2.3 -5.36,4.55 -8.18,6.75c-2.83,2.19 -5.02,4.21 -8.07,6.23c-0.7,0.46 -1.56,0.46 -2.25,0c-5.88,-3.64 -12.05,-7.73 -17.3,-12.18c-2.59,-2.25 -5.13,-4.55 -7.55,-7.03c-2.42,-2.43 -4.72,-4.97 -6.97,-7.56c-4.44,-5.25 -8.42,-10.85 -11.93,-16.67c-1.73,-2.95 -3.35,-5.95 -4.84,-9c-1.45,-3.12 -2.83,-6.23 -3.87,-9.46c-0.06,-0.12 0,-0.24 0.12,-0.29l0.06,0l25.01,-0.98c0.69,0 1.27,0.52 1.27,1.15c0,0.69 -0.52,1.27 -1.15,1.27c0.06,-0.17 0,-0.17 0,-0.17z",
    fill: "white",
    id: "svg_2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m140.62,97.17c-7.27,2.36 -35.97,2.13 -48.13,2.13c-11.24,0 0,0 -24.91,0l-22.77,-0.06c0,0 11.13,30.29 47.68,51.29c0,0 31.64,-17.94 48.13,-53.36z",
    fill: "white",
    id: "svg_3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m93.23,28.29l-57.35,19.55c0,0 1.67,13.33 2.42,17.71c0.75,4.16 3.52,16.62 3.52,16.62c20.53,0 38.33,-5.31 51.41,-5.31c11.07,0 23.27,0 23.27,0l28.5,0c0,0 2.82,-10.15 3.4,-13.61c0.63,-3.7 1.27,-14.89 1.27,-14.89l-56.44,-20.07z",
    fill: "#FDFDFD",
    id: "svg_4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 92.5,
    cy: 68.5,
    fill: "white",
    id: "svg_5",
    r: 15.5,
    stroke: "#DDDDDD",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#FDFDFD",
    height: 20,
    id: "svg_6",
    rx: 10,
    stroke: "#DDDDDD",
    strokeWidth: 2,
    width: 55,
    x: 65,
    y: 88
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovfulllogosmall);
export default __webpack_public_path__ + "static/media/govfulllogosmall.45457765a4619c2c198bde3d53b81618.svg";
export { ForwardRef as ReactComponent };